import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RoutesWithOptions } from '@app/interfaces';
import { Platform } from '@app/classes';
import { EmployeeAccessGuard, FeatureGuard, PermissionGuard } from '@app/guards';
import { FeatureFlag } from '@app/enums';
import {
    ChangeRequestTemplateIndexView,
    ChangeRequestTemplateUpdateView,
    ChangeRequestIndexView,
    ChangeRequestStoreView,
    ChangeRequestShowView,
} from '@change-requests/views';
import { ChangeRequestsResolver } from '@change-requests/change-requests.resolver';

const routes: RoutesWithOptions = [
    {
        path: '',
        redirectTo: 'templates',
        pathMatch: 'full',
    },
    {
        path: '',
        canActivate: [FeatureGuard],
        data: {
            feature: { flags: [FeatureFlag.changeRequests] },
        },
        children: [
            {
                path: 'templates',
                canActivate: [PermissionGuard],
                component: ChangeRequestTemplateIndexView,
                data: {
                    permission: Platform.permission.administrate,
                },
            },
            {
                path: 'templates/:changeRequestTemplate',
                canActivate: [PermissionGuard],
                component: ChangeRequestTemplateUpdateView,
                data: {
                    permission: Platform.permission.administrate,
                },
                resolve: {
                    models: ChangeRequestsResolver,
                },
            },
            {
                path: 'requests',
                canActivate: [PermissionGuard],
                component: ChangeRequestIndexView,
                data: {
                    permission: Platform.people.permission.view,
                },
            },
            {
                path: 'requests/:changeRequest',
                component: ChangeRequestShowView,
                resolve: {
                    models: ChangeRequestsResolver,
                },
            },
            {
                path: 'templates/:changeRequestTemplate/employees/:employee/new',
                component: ChangeRequestStoreView,
                canActivate: [EmployeeAccessGuard],
                resolve: {
                    models: ChangeRequestsResolver,
                },
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ChangeRequestsRouterModule {}
